import { rankings } from "@/mocks/comics";
import { SectionHeading } from "./HotComics";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-accent-500",
  down: "ri-arrow-down-line text-primary-500",
  flat: "ri-equalizer-line text-secondary-400",
};

export default function Ranking() {
  const topThree = rankings.slice(0, 3);
  const rest = rankings.slice(3);

  return (
    <section className="mx-auto px-4 md:px-8 py-14 md:py-20 bg-background-900/50 border-y border-background-800/50">
      <SectionHeading
        anchor="ranking"
        kicker="人气榜单 · RANKING"
        title="韩漫免费人气总榜"
        desc="根据全站阅读热度与读者收藏实时汇总的人气排行，上榜作品皆为口碑与流量双丰收的热门佳作。"
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6">
        {/* 前三名大卡 */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {topThree.map((r) => (
            <div
              key={r.rank}
              className={`flex flex-col rounded-lg overflow-hidden border ${
                r.rank === 1
                  ? "border-primary-500/50 bg-primary-600/10"
                  : r.rank === 2
                  ? "border-accent-500/40 bg-accent-500/10"
                  : "border-secondary-500/30 bg-secondary-500/10"
              }`}
            >
              <div className="flex items-center justify-between px-4 pt-4">
                <span
                  className={`font-heading text-4xl font-black ${
                    r.rank === 1
                      ? "text-primary-400"
                      : r.rank === 2
                      ? "text-accent-400"
                      : "text-secondary-300"
                  }`}
                >
                  {String(r.rank).padStart(2, "0")}
                </span>
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-950/50">
                  <i className={trendIcon[r.trend]} />
                </span>
              </div>
              <div className="flex flex-col flex-1 px-4 pb-4 pt-3">
                <p className="text-sm font-semibold text-foreground-100 leading-snug line-clamp-2">{r.title}</p>
                <p className="mt-1 text-xs text-foreground-500">{r.category}</p>
                <p className="mt-auto pt-3 text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line" /> {r.views} 次阅读
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* 4-8名列表 */}
        <div className="rounded-lg bg-background-900/70 border border-background-800/60 divide-y divide-background-800/50">
          {rest.map((r) => (
            <div
              key={r.rank}
              className="flex items-center gap-4 px-4 md:px-5 py-3 hover:bg-background-800/40 transition-colors"
            >
              <span className="w-7 text-center font-heading text-lg font-bold text-foreground-400">
                {String(r.rank).padStart(2, "0")}
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-foreground-100 truncate">{r.title}</p>
                <p className="text-xs text-foreground-500">{r.category}</p>
              </div>
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-950/50 shrink-0">
                <i className={trendIcon[r.trend]} />
              </span>
              <span className="text-xs text-foreground-400 shrink-0">{r.views}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}